// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qb-0";